/* src/app/notify-templates/notify-template-form-dialog/notify-template-form-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.notify-template-form-dialog .dialog-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 2em 0;
  overflow-y: hidden;
}
@media screen and (min-width: 48rem) {
  .notify-template-form-dialog .dialog-content-wrapper {
    flex-direction: row;
    padding: 0;
  }
}
@media screen and (min-width: 48rem) {
  .notify-template-form-dialog .dialog-content-wrapper .template-form,
  .notify-template-form-dialog .dialog-content-wrapper .template-preview {
    width: 47%;
  }
}
@media screen and (min-width: 48rem) {
  .notify-template-form-dialog .dialog-content-wrapper .template-form {
    padding-right: 1em;
  }
}
.notify-template-form-dialog .dialog-content-wrapper .template-preview {
  display: none;
}
@media screen and (min-width: 48rem) {
  .notify-template-form-dialog .dialog-content-wrapper .template-preview {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding-left: 1em;
  }
}
.notify-template-form-dialog .dialog-content-wrapper .template-preview .template-preview-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #e8e8e6;
  border-bottom: solid medium #004791;
  height: 2em;
  padding: 0.5em 2em 0.5em 0.5em;
  margin: 1em -2em 1em -0.5em;
}
@media screen and (min-width: 48rem) {
  .divider.vertical {
    border-left: solid thin #e8e8e6;
    margin: -2em 0;
  }
}
/*# sourceMappingURL=notify-template-form-dialog.component.css.map */
